import { useTranslation } from "react-i18next";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Tooltip } from "@/components/ui/Tooltip";
import { cn } from "@/utils/cn";

interface SidebarEdgeToggleProps {
  collapsed: boolean;
  onToggle: () => void;
  /**
   * rail — absolute on the sidebar edge (close when open; expand when collapsed)
   * open — fixed open-only tab below the header (laptop collapsed rail)
   * mobile — fixed open tab when the sidebar is fully off-screen
   */
  variant?: "rail" | "open" | "mobile";
}

export function SidebarEdgeToggle({
  collapsed,
  onToggle,
  variant = "rail",
}: SidebarEdgeToggleProps) {
  const { t } = useTranslation("common");
  const label = collapsed ? t("labels.openSidebar") : t("labels.closeSidebar");
  const showOpenIcon = collapsed || variant === "open" || variant === "mobile";
  return (
    <Tooltip content={label} placement="right" trigger="hover">
      <button
        type="button"
        onMouseDown={(event) => event.preventDefault()}
        onClick={onToggle}
        aria-label={label}
        className={cn(
          "workspace-sidebar-edge-toggle",
          variant === "open" && "workspace-sidebar-edge-toggle--open",
          variant === "mobile" && "workspace-sidebar-edge-toggle--mobile",
          variant === "rail" &&
            (collapsed
              ? "workspace-sidebar-edge-toggle--expand"
              : "workspace-sidebar-edge-toggle--collapse"),
        )}
      >
        {showOpenIcon ? (
          <ChevronRightIcon sx={{ fontSize: 18 }} />
        ) : (
          <ChevronLeftIcon sx={{ fontSize: 18 }} />
        )}
      </button>
    </Tooltip>
  );
}
